import { render, staticRenderFns } from "./nursingHomeIndex.vue?vue&type=template&id=41d36fb0&scoped=true&"
import script from "./nursingHomeIndex.vue?vue&type=script&lang=js&"
export * from "./nursingHomeIndex.vue?vue&type=script&lang=js&"
import style0 from "./nursingHomeIndex.vue?vue&type=style&index=0&id=41d36fb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d36fb0",
  null
  
)

export default component.exports